import { callApiWithAuthorization } from "../CallApi";

export async function getTenants(id) {
    const request = await callApiWithAuthorization("/api/v0/tenants/" + id);
    const response = await request.json();
    return response;
}

export async function getTenantProject(tenantId, masterProjectId) {
    const request = await callApiWithAuthorization(`/api/v0/tenant/${tenantId}/project/${masterProjectId}`);
    const response = await request.json();
    return response;
}

export async function getTenantsByProjectId(projectId) {
    const request = await callApiWithAuthorization(`/api/v0/project/${projectId}/tenants`);
    const response = await request.json();
    return response;
}

export async function getInvitations(organizationId) {
    const request = await callApiWithAuthorization("/api/v0/invitations/" + organizationId);
    const response = await request.json();
    return response;
}

export async function inviteTenant(properties) {
    const requiredProperties = ["tenantName", "tenantEmail", "masterOrganizationId", "masterAppId", "masterProjectId", "masterUserId"];
    for (const prop of requiredProperties) {
        if (!properties[prop]) {
            throw new Error(`Missing required property: ${prop}`);
        }
    }

    const request = await callApiWithAuthorization("/api/v0/tenant", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            tenantName: properties.tenantName,
            tenantEmail: properties.tenantEmail,
            masterOrganizationId: properties.masterOrganizationId,
            masterProjectId: properties.masterProjectId,
            masterAppId: properties.masterAppId,
            masterUserId: properties.masterUserId,
            enableTenantTestEnvironment: properties.enableTenantTestEnvironment || false
        })
    });
    const response = await request.json();
    return response;
}

export async function addTenantProject(tenantId, properties) {
    const requiredProperties = ["masterProjectId", "masterAppId", "subscriptionId"];
    for (const prop of requiredProperties) {
        if (!properties[prop]) {
            throw new Error(`Missing required property: ${prop}`);
        }
    }

    const request = await callApiWithAuthorization(`/api/v0/tenant/${tenantId}/project`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(properties)
    });
    const response = await request.json();
    return response;
}

export async function resentInvitation(tenantId, masterProjectId, subscriptionId) {
    const request = await callApiWithAuthorization(`/api/v0/tenant/${tenantId}/project/${masterProjectId}/resentInvitation`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            subscriptionId: subscriptionId
        })
    });
    const response = await request.json();
    return response;
}

export async function rejectInvitation(tenantId, masterProjectId, subscriptionId) {
    const request = await callApiWithAuthorization(`/api/v0/tenant/${tenantId}/project/${masterProjectId}/rejectInvitation`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            subscriptionId: subscriptionId
        })
    });
    const response = await request.json();
    return response;
}

export async function updateTenant(tenantId, properties) {
    const request = await callApiWithAuthorization(`/api/v0/tenant/${tenantId}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(properties)
    });
    const response = await request.json();
    return response;
}

export async function updateTenantProject(tenantId, masterProjectId, properties) {
    const request = await callApiWithAuthorization(`/api/v0/tenant/${tenantId}/project/${masterProjectId}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(properties)
    });
    const response = await request.json();
    return response;
}

export async function deleteTenant(tenantId) {
    const request = await callApiWithAuthorization(`/api/v0/tenant/${tenantId}`, {
        method: "DELETE"
    });
    const response = await request.json();
    return response;
}

export async function deleteTenantProject(tenantId, masterProjectId) {
    const request = await callApiWithAuthorization(`/api/v0/tenant/${tenantId}/project/${masterProjectId}`, {
        method: "DELETE"
    });
    const response = await request.json();
    return response;
}

export async function syncMasterProjectToAllTenants(masterProjectId, tenantsToSync, azureId) {
    
    if (!masterProjectId) {
        throw new Error("Missing required property: masterProjectId");
    }
    if (!tenantsToSync || tenantsToSync.length === 0) {
        throw new Error("Missing required property: tenantsToSync   or it is empty");
    }
    if (!azureId) {
        throw new Error("Missing required property: azureId");
    }
    const request = await callApiWithAuthorization(`/api/v0/syncMasterProjectToAllTenants/${masterProjectId}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            tenantsToSync,
            azureId
        })
    });
    const response = await request.json();
    return response;
}

export async function cloneMasterAppsToTenant(tenantId, masterProjectId, azureId) {
    if (!tenantId) {
        throw new Error("Missing required property: tenantId");
    }
    if (!masterProjectId) {
        throw new Error("Missing required property: masterProjectId");
    }
    if (!azureId) {
        throw new Error("Missing required property: azureId");
    }
    const request = await callApiWithAuthorization(`/api/v0/cloneMasterAppsToTenant`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            tenantId: tenantId,
            masterProjectId: masterProjectId,
            azureId: azureId,
        })
    });
    const response = await request.json();
    return response;
}